export enum ImportType {
  Sportingpulse = "Sportingpulse",
  NunawadingReferees = "NunawadingReferees",
}

export namespace ImportType {
  export function all(): ImportType[] {
    return [ImportType.Sportingpulse, ImportType.NunawadingReferees];
  }
}
